export enum LocationUnit {
  Km = 'Km',
  Mi = 'Mi'
}
